import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ImageBackground, Platform } from 'react-native';
import PlatformIcon from '../common/PlatformIcon';
import { ORANGE_ACTION, ACTION_ICON_COLOR } from '../../constants/colors';

export interface EditorHeaderProps {
  title?: string;
  subtitle?: string;
  backgroundSource?: any;
  onBack?: () => void;
  onEdit?: () => void;
  // Optional override for the right-side action
  rightIconName?: string; // e.g. 'edit' | 'done'
  onRightPress?: () => void;
  showLocationBadge?: boolean;
  showRightAction?: boolean;
  compact?: boolean; // 紧凑模式，用于移动端
  statusBarHeight?: number; // Status bar 高度，用于延伸背景到 status bar
}

const EditorHeader: React.FC<EditorHeaderProps> = ({ title, subtitle, backgroundSource, onBack, onEdit, rightIconName, onRightPress, showLocationBadge = true, showRightAction = true, statusBarHeight = 0 }) => {
  const content = (
    <View style={[styles.row, { paddingTop: 18 + statusBarHeight, height: 72 + statusBarHeight }]}>
      <TouchableOpacity style={[styles.circle, styles.leftCircle, styles.actionCircle, { top: 18 + statusBarHeight }]} onPress={onBack} activeOpacity={0.85}>
        <PlatformIcon name="arrow-back" size={20} color={ACTION_ICON_COLOR} family="MaterialIcons" />
      </TouchableOpacity>

      <View style={styles.titleWrap}>
        <Text style={styles.title}>{title || '行程编辑'}</Text>
        {showLocationBadge && subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
      </View>

      {showRightAction && (onRightPress || onEdit) ? (
        <TouchableOpacity style={[styles.circle, styles.rightCircle, styles.actionCircle, { top: 18 + statusBarHeight }]} onPress={onRightPress || onEdit} activeOpacity={0.85}>
          <PlatformIcon name={rightIconName || 'edit'} size={18} color={ACTION_ICON_COLOR} family="MaterialIcons" />
        </TouchableOpacity>
      ) : null}
    </View>
  );

  if (backgroundSource) {
    return (
      <ImageBackground source={backgroundSource} style={[styles.headerCover, statusBarHeight > 0 && { height: 182 + statusBarHeight }]} imageStyle={styles.headerCoverImage} resizeMode="cover">
        <View style={styles.overlay} />
        {content}
      </ImageBackground>
    );
  }

  return (
    <View style={[styles.headerCover, styles.headerCoverFallback, statusBarHeight > 0 && { height: 182 + statusBarHeight }]}>
      {content}
    </View>
  );
};

const styles = StyleSheet.create({
  headerCover: { height: 182, width: '100%', overflow: 'hidden' },
  headerCoverFallback: { backgroundColor: '#FF6B35' },
  headerCoverImage: { resizeMode: 'cover' },
  overlay: { 
    position: 'absolute', 
    top: 0, 
    left: 0, 
    right: 0, 
    bottom: 0, 
    backgroundColor: 'rgba(0, 0, 0, 0.25)' 
  },
  row: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingTop: 18, paddingBottom: 8, height: 72 },
  circle: { width: 40, height: 40, borderRadius: 20, backgroundColor: 'rgba(255,255,255,0.95)', alignItems: 'center', justifyContent: 'center' },
  leftCircle: { position: 'absolute', left: 12, top: 18 },
  rightCircle: { position: 'absolute', right: 12, top: 18 },
  actionCircle: {
    backgroundColor: ORANGE_ACTION,
    // Use CSS boxShadow on web to avoid react-native-web deprecation warnings
    ...(Platform.select ? Platform.select({ web: { boxShadow: '0 4px 12px rgba(0,0,0,0.12)' }, default: { shadowColor: '#000', shadowOffset: { width: 0, height: 4 }, shadowOpacity: 0.5, shadowRadius: 6, elevation: 10 } }) : { shadowColor: '#000', shadowOffset: { width: 0, height: 4 }, shadowOpacity: 0.5, shadowRadius: 6, elevation: 10 }),
  },
  titleWrap: { alignItems: 'center', justifyContent: 'center' },
  title: { color: '#fff', fontSize: 22, fontWeight: '700' },
  subtitle: { color: 'rgba(255,255,255,0.95)', marginTop: 6 },
});

export default EditorHeader;
